export default {
	'ERROR': 'Error',
	'ERROR_DEPLOY': 'Deploy in progress..',
	'ERROR_BACKEND': 'Backend error',
	'ERROR_THROTTLED': 'Request throttled, please try again later.',
	'YES': 'Yes',
	'NO': 'No',
}



// WEBPACK FOOTER //
// ./src/assets/locales/en/base.js